import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { errorStyle } from "../../../styles";

interface Props {
  loading: boolean;
  error?: string;
  empty?: boolean;
  emptyMessage?: string;
  children: ReactNode;
}

/**
 * Replaces the ad-hoc `{loading ? <p>Loading…</p> : error ? ... : children}` block
 * repeated (with slightly different wording each time) across admin components.
 * No outer padding — callers already control that via their own wrapper, and it
 * varied per call site before this existed.
 */
export default function AsyncState({ loading, error, empty, emptyMessage, children }: Props) {
  const { t } = useTranslation();

  if (error) return <p style={errorStyle}>{error}</p>;
  if (loading) return <p style={{ color: "var(--color-text-muted)" }}>{t("common.loading")}</p>;
  if (empty) return <p style={{ color: "var(--color-text-muted)" }}>{emptyMessage ?? t("common.noData")}</p>;
  return <>{children}</>;
}
